// src/pages/TagalogMorePage.js
import React from "react";
import PrayerButtonGrid from "../components/PrayerButtonGrid";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const categories = [
  "wisdom_prayer",
  "peace_prayer",
  "patience_prayer",
  "gratitude_prayer",
  "faith_prayer",
  "forgiveness_prayer",
  "guidance_prayer",
  "strength_prayer",
  "boyfriend",
  "girlfriend",
  "purpose_prayers",
  "anxiety_prayers",
  "dog_prayer",
  "cat_prayer"
];

const labels = {
  wisdom_prayer: "Karunungan",
  peace_prayer: "Kapayapaan",
  patience_prayer: "Pagtitiis",
  gratitude_prayer: "Pasasalamat",
  faith_prayer: "Pananampalataya",
  forgiveness_prayer: "Kapatawaran",
  guidance_prayer: "Gabay",
  strength_prayer: "Lakas",
  boyfriend: "Kasintahan (Lalaki)",
  girlfriend: "Kasintahan (Babae)",
  purpose_prayers: "Layunin",
  anxiety_prayers: "Pag-aalala",
  dog_prayer: "Aso",
  cat_prayer: "Pusa"
};

function TagalogMorePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Higit Pang Panalangin</h1>
      <PrayerButtonGrid
        categories={categories}
        labels={labels}
        onSelect={(cat) =>
          navigate(`/tl/prayer/${cat}`, { state: { from: "/tl/more" } })
        }
      />
      <div className="text-center mt-4">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate("/tl")}>
          Bumalik sa Simula
        </Button>
      </div>
    </Container>
  );
}

export default TagalogMorePage;
